import React, { useState, useEffect } from 'react';
import Axios from 'axios';

import Dropdown from '../../components/react/Dropdown';
import Card from './components/Card';

const TabFacetedListing = ({
  endpoint,
  language,
  facetLabel,
  allMobileLabel
}) => {
  const [loading, setLoading] = useState([]);
  const [facets, setFacets] = useState(null);
  const [selectedFacet, setSelectedFacet] = useState(null);
  const [results, setResults] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await Axios({
          method: 'GET',
          url: endpoint,
          params: { language }
        });

        setResults(data.resultListing);
        setFacets(data.facets[0]);
        setSelectedFacet(data.facets[0].options[0]);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getSelectedFacet = () => {
    if (selectedFacet) {
      return {
        ...selectedFacet,
        label: selectedFacet.value ? selectedFacet.name : allMobileLabel
      };
    }
  };

  return (
    <div className="tab-faceted-listing container">
      {!!facets && (
        <div className="tab-faceted-listing__facets">
          <Dropdown
            label={facetLabel}
            selectedOption={getSelectedFacet()}
            options={facets.options.map(option => ({
              ...option,
              label: option.name
            }))}
            onChange={setSelectedFacet}
            compareAttr="value"
            innerLabel={facets.name}
          />
          <div className="tab-faceted-listing__facets-list">
            <p className="tab-faceted-listing__facets-label">{facets.name}</p>
            <div className="tab-faceted-listing__facets-options">
              {facets.options.map(option => (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => setSelectedFacet(option)}
                  className={
                    option.value === selectedFacet?.value ? 'selected' : null
                  }
                >
                  {option.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
      <div className="tab-faceted-listing__list">
        {results
          .filter(result =>
            selectedFacet?.value
              ? result.category.some(
                category => category === selectedFacet.value
              )
              : true
          )
          .map(result => (
            <Card key={result.id} {...result} />
          ))}
      </div>
    </div>
  );
};
export default TabFacetedListing;
